
export const de = {
  auth: {
    login: "Anmelden",
    startFreeTrial: "Kostenlose Testversion starten",
    register: "Registrieren",
    email: "E-Mail",
    password: "Passwort",
    forgotPassword: "Passwort vergessen?",
    alreadyHaveAccount: "Bereits ein Konto?",
    dontHaveAccount: "Noch kein Konto?",
    errorDescription: "Ein Fehler ist aufgetreten",
    errorTitle: "Fehler",
    successTitle: "Erfolg",
    successDescription: "Operation erfolgreich",
    continueWithGoogle: "Mit Google fortfahren",
    createAccount: "Konto erstellen",
    trialDescription: "14 Tage kostenlose Testversion",
    emailPlaceholder: "ihre@email.com",
    creating: "Erstelle...",
    create: "Erstellen",
    errorMessage: "Ein Fehler ist aufgetreten"
  },
  navigation: {
    pricing: "Preise",
    about: "Über uns",
    contact: "Kontakt",
    themes: "Designs",
    resources: "Ressourcen",
    home: "Start",
    dashboard: "Dashboard",
    products: "Produkte",
    orders: "Bestellungen",
    customers: "Kunden",
    settings: "Einstellungen"
  },
  footer: {
    acceptedPayments: "Akzeptierte Zahlungen",
    allRightsReserved: "Alle Rechte vorbehalten",
    quickLinks: "Schnelllinks",
    legalNotice: "Impressum",
    accessibility: "Barrierefreiheit",
    termsOfUse: "Nutzungsbedingungen",
    support: "Support",
    followUs: "Folgen Sie uns",
    socialMedia: "Finden Sie uns in sozialen Medien",
    newsletter: "Newsletter",
    subscribeNewsletter: "Abonnieren Sie unseren Newsletter",
    emailPlaceholder: "Ihre E-Mail",
    subscribe: "Abonnieren",
    changeLanguage: "Sprache ändern"
  },
  pricing: {
    title: "Pläne und Preise",
    subtitle: "Wählen Sie den Plan, der zu Ihnen passt",
    startTrial: "Kostenlose Testversion starten",
    mostPopular: "Am beliebtesten",
    freeTrial: "14 Tage kostenlose Testversion",
    perMonth: "/Monat",
    basic: {
      name: "Basic",
      price: "11",
      description: "Zum Einstieg",
      features: [
        "1 Shop",
        "100 Produkte",
        "E-Mail-Support"
      ]
    },
    pro: {
      name: "Pro",
      price: "25",
      description: "Für Profis",
      features: [
        "3 Shops",
        "1000 Produkte",
        "Prioritäts-Support",
        "Erweiterte Analysen"
      ]
    },
    enterprise: {
      name: "Enterprise",
      price: "97",
      description: "Für große Unternehmen",
      features: [
        "Unbegrenzte Shops",
        "Unbegrenzte Produkte",
        "Dedizierter Support",
        "Eigene API"
      ]
    }
  },
  profile: {
    title: "Mein Profil",
    fullName: "Vollständiger Name",
    phoneNumber: "Telefonnummer",
    update: "Aktualisieren",
    updating: "Aktualisiere...",
    success: "Profil erfolgreich aktualisiert",
    error: "Fehler beim Aktualisieren des Profils"
  },
  common: {
    loading: "Lade...",
    error: "Fehler",
    success: "Erfolg",
    save: "Speichern",
    cancel: "Abbrechen",
    delete: "Löschen",
    edit: "Bearbeiten",
    create: "Erstellen",
    search: "Suchen",
    filter: "Filtern",
    sort: "Sortieren",
    actions: "Aktionen",
    confirm: "Bestätigen",
    back: "Zurück",
    next: "Weiter",
    previous: "Zurück",
    close: "Schließen"
  }
};
